import styled from "styled-components";

export const PixSummaryContainer = styled.div`
  @media (min-width: 768px) {
    align-content: flex-start;
    justify-content: flex-start;
  }
`;
